module.exports = __webpack_public_path__ + "img/godetailgeo.f3bc55b7.svg";